import { useEffect } from 'react';

import { Button, Col, Form, Input, Row } from 'antd';

import { visibleDrawerVar } from 'api/cache';
import {
  colProps,
  FILTER_PARAMS_DATA_TYPE_SUFFIX,
  FILTER_PARAMS_OPERATOR_SUFFIX,
  FILTER_PARAMS_PREFIX
} from 'appConstants';
import UserStatusSelect from 'components/UserStatusSelect';
import UserTypeSelect from 'components/UserTypeSelect/UserTypeSelect';
import FormBase from 'containers/FormBase';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import { processFormItemName } from 'utils/filter';

const UserFilter = () => {
  const [form] = Form.useForm();
  const history = useHistory();

  useEffect(() => {
    form.setFieldsValue(queryString.parse(history.location.search));
  }, [form, history.location.search]);

  return (
    <FormBase form={form}>
      <Row gutter={8}>
        <Col {...colProps}>
          <Form.Item
            name={processFormItemName({
              prefix: FILTER_PARAMS_PREFIX,
              name: 'name',
              operatorSuffix: FILTER_PARAMS_OPERATOR_SUFFIX.CONTAINS
            })}
            label="Họ tên"
          >
            <Input placeholder="Nhập họ tên" />
          </Form.Item>
        </Col>

        <Col {...colProps}>
          <Form.Item
            name={processFormItemName({
              prefix: FILTER_PARAMS_PREFIX,
              name: 'email',
              operatorSuffix: FILTER_PARAMS_OPERATOR_SUFFIX.CONTAINS
            })}
            label="Email"
          >
            <Input placeholder="Nhập email" />
          </Form.Item>
        </Col>

        <Col {...colProps}>
          <Form.Item
            name={processFormItemName({
              prefix: FILTER_PARAMS_PREFIX,
              name: 'status',
              operatorSuffix: FILTER_PARAMS_OPERATOR_SUFFIX.EQ,
              dataTypeSuffix: FILTER_PARAMS_DATA_TYPE_SUFFIX.INT
            })}
            label="Trạng thái"
          >
            <UserStatusSelect style={{ width: '100%' }} />
          </Form.Item>
        </Col>

        <Col {...colProps}>
          <Form.Item
            name={processFormItemName({
              prefix: FILTER_PARAMS_PREFIX,
              name: 'userType',
              operatorSuffix: FILTER_PARAMS_OPERATOR_SUFFIX.EQ,
              dataTypeSuffix: FILTER_PARAMS_DATA_TYPE_SUFFIX.INT
            })}
            label="Loại user"
          >
            <UserTypeSelect integerValue={true} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        {/* <Col {...colProps}>
          <Form.Item
            name={processFormItemName({
              prefix: FILTER_PARAMS_PREFIX,
              name: 'channels',
              operatorSuffix: FILTER_PARAMS_OPERATOR_SUFFIX.EQ
            })}
            label="Kênh"
          >
            <ChannelSelect style={{ style: '100%' }} />
          </Form.Item>
        </Col> */}
      </Row>

      <Row gutter={8} justify="end">
        <Col>
          <Button htmlType="submit">Lọc</Button>
        </Col>
        <Col>
          <Button
            onClick={() => visibleDrawerVar({ visible: true })}
            type="primary"
          >
            Thêm
          </Button>
        </Col>
      </Row>
    </FormBase>
  );
};

export default UserFilter;
